import SidebarContent from "./SidebarContent";
import Background from "../../assets/icons/pback.png";
import { motion } from "framer-motion";

const MobileSidebar = () => {
  return (
    <motion.aside
      initial={{
        x: 500,
      }}
      animate={{
        x: 0,
      }}
      transition={{
        duration: 0.2,
      }}
      exit={{
        x: 500,
      }}
      className="fixed bg-white inset-y-0 z-50 flex-shrink-0 w-full sm:w-64 mt-[4.5rem] overflow-y-auto md:hidden"
    >
      <SidebarContent />
      <div
        className="fixed w-64 -z-10 h-screen bottom-0 right-0 transform bg-cover opacity-5 bg-no-repeat"
        style={{
          backgroundImage: `url(${Background})`,
          filter: "brightness(170%)",
        }}
      />
    </motion.aside>
  );
};

export default MobileSidebar;
